import { graphql } from '@graphql/__generated'

export const GET_PAST_EVENTS = graphql(`
  query GetPastEvents {
    getPastEvents {
      eventId
      organizerId
      isPublished
      isComplete
      event {
        eventType
        bannerImage
        description
        eventMainColour
        eventBackgroundColour
        eventTextColour
        endDateTime
        shortDescription
        startDateTime
        entryDateTime
        title
        organizationName
        thumbnailImage
        donationUrl
        currency
      }
      attendees {
        name
      }
      fundraising {
        goal
        donors
        raised
      }
      speakers {
        email
      }
    }
  }
`)
